import React from 'react'

import { useTranslation } from 'react-i18next'
import { FieldProps } from '../../../../../../../@types/types'
import { OtherFacilitiesScreenValidationResult } from '../../../../../../../@types/validation-types'
import { NumberInput } from '../../../../../../common/inputs/numberInput/NumberInput'
import { getDefaultClasses } from '../../../../../../../utils/style-utils'
import { parseNumber } from '../../../../../../../services/validation/rules/validationFunctions'
import { formatNumber } from '../../../../../../../i18next/decimal'

const PricePerSQM: React.FC<FieldProps<OtherFacilitiesScreenValidationResult>> = ({
  screenName,
  insertionData,
  validationMessages,
  wrapperClassName = getDefaultClasses('full'),
  onChange,
}) => {
  const { t } = useTranslation()
  return (
    <div className={wrapperClassName}>
      <NumberInput
        id='price-per-sqm'
        propertyName='pricePerSQM'
        placeholder=''
        label={<span>{t('wizard.screen.otherFacilities.pricePerSQM', 'Price Per SQM')}</span>}
        value={insertionData.pricePerSQM ? parseNumber(insertionData.pricePerSQM) : undefined}
        minPrecision={0}
        maxPrecision={2}
        maxLength={11}
        affixRight='unit'
        unitRight='eur'
        errors={validationMessages?.pricePerSQM ?? []}
        doOnFieldChange={(property, value) => onChange({ screen: screenName, property }, formatNumber(value))}
      />
    </div>
  )
}

export default PricePerSQM
